import * as React from 'react';

import type { StatsigOptions, StatsigUser } from '@statsig/react-bindings';
import { StatsigProvider, useClientBootstrapInit } from '@statsig/react-bindings';

type Props = React.PropsWithChildren<{
  user: StatsigUser;
  values: string;
  clientKey: string;
  clientOptions?: StatsigOptions | null;
  loadingComponent?: React.ReactNode;
}>;

export default function BootstrapClientSubProvider({
  user,
  values,
  children,
  clientKey,
  clientOptions,
  loadingComponent,
}: Props): React.ReactElement {
  // Creates a new statsig client or retrives one by clientKey from global
  const client = useClientBootstrapInit(clientKey, user, values, clientOptions);

  return (
    <StatsigProvider loadingComponent={loadingComponent} client={client}>
      {children}
    </StatsigProvider>
  );
}
